<div class="wrap">
  <div class="content" [ngClass]="{'no-block' : !notice_left_to_display && !notice_right_to_display}">
    <ng-container *ngIf="!isMobile">
      <div class="container-block" [ngClass]="{'no-left-block': !notice_left_to_display}">
        <div class="ticker-header">
          <div class="ticker-icon">
            <fa-icon [icon]="getFaIcon('faBullhorn')"></fa-icon>
          </div>
          <span class="ticker-label">Actualités</span>
        </div>
        <div class="content-left" #scrollContainerLeft tabindex="0" (mouseenter)="pauseLeft()" (mouseleave)="resumeLeft()">
          <ng-container *ngIf="notices_left.length > 2; else elseTemplate">
            <ng-container *ngFor="let notice of notices_left; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>

                <ng-container *ngIf="notice?.linkLabel; else leftTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #leftTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_left?.length"></div>
            </ng-container>
            <!-- Duplicate  -->
            <ng-container *ngFor="let notice of notices_left; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>

                <ng-container *ngIf="notice?.linkLabel; else leftTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #leftTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_left?.length"></div>
            </ng-container>

            <!-- Duplicate  -->
            <ng-container *ngFor="let notice of notices_left; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>

                <ng-container *ngIf="notice?.linkLabel; else leftTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #leftTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_left?.length"></div>
            </ng-container>
          </ng-container>

          <ng-template #elseTemplate>
            <ng-container *ngFor="let notice of notices_left; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>

                <ng-container *ngIf="notice?.linkLabel; else leftTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #leftTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_left?.length"></div>
            </ng-container>
          </ng-template>

        </div>
      </div>
    </ng-container>

    <div class="home-router" [@fadeAnimation]="routeAnimationState" id="home_router_outlet">
      <router-outlet #o="outlet"></router-outlet>
    </div>

    <ng-container *ngIf="!isMobile">
      <div class="container-block" [ngClass]="{'no-right-block': !notice_right_to_display}">
        <div class="ticker-header">
          <div class="ticker-icon">
            <fa-icon [icon]="getFaIcon('faBullhorn')"></fa-icon>
          </div>
          <span class="ticker-label">Actualités</span>
        </div>
        <div class="content-right" #scrollContainerRight tabindex="0" (mouseenter)="pauseRight()" (mouseleave)="resumeRight()">
          <ng-container *ngIf="notices_right.length > 2; else elseTemplate">
            <ng-container *ngFor="let notice of notices_right; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>
                <ng-container *ngIf="notice?.linkLabel; else rightTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #rightTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_right?.length"></div>
            </ng-container>

            <ng-container *ngFor="let notice of notices_right; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>
                <ng-container *ngIf="notice?.linkLabel; else rightTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #rightTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_right?.length"></div>
            </ng-container>

            <ng-container *ngFor="let notice of notices_right; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>
                <ng-container *ngIf="notice?.linkLabel; else rightTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #rightTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_right?.length"></div>
            </ng-container>
          </ng-container>

          <ng-template #elseTemplate>
            <ng-container *ngFor="let notice of notices_right; let i=index">
              <div class="middle">
                <ng-container *ngIf="notice.thumbImage">
                  <div class="thumbImage" (click)="seeDetailsNotice(notice)" [innerHTML]="notice.thumbImage"></div>
                </ng-container>
                <ng-container *ngIf="notice?.linkLabel; else rightTemplate">
                  <div class="url" (click)="goToLink(notice)" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    {{ notice?.linkLabel }}
                  </div>
                </ng-container>
                <ng-template #rightTemplate>
                  <div class="url" (click)="goToLink(notice)" *ngIf="notice?.linkUrl" matTooltip="{{ notice?.linkUrl }}" matTooltipPosition="above">
                    <fa-icon [icon]="getFaIcon('faExternalLinkSquareAlt')" appChangeColorTheme attribute="color" ></fa-icon>
                    <span>Lien externe</span>
                  </div>
                </ng-template>
              </div>
              <div class="divider" *ngIf="i < notices_right?.length"></div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</div>
